export const MobileScreenWidth = 450;
export const LightGalleryLicense = 'E26F7E67-F9DE-4E76-9532-68B0B12EF858';
